/* eslint-disable */
import * as Types from '../../../../../types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions = {} as const;
export type InProductMessagesCountQueryVariables = Types.Exact<{
  input: Types.InProductMessagesCountInput;
}>;

export type InProductMessagesCountQuery = {
  __typename?: 'Query';
  inProductMessagesCount: {
    __typename?: 'InProductMessagesCount';
    totalCount: number;
  };
};

export const InProductMessagesCountDocument = gql`
  query inProductMessagesCount($input: InProductMessagesCountInput!) {
    inProductMessagesCount(input: $input) {
      totalCount
    }
  }
`;

/**
 * __useInProductMessagesCountQuery__
 *
 * To run a query within a React component, call `useInProductMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProductMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProductMessagesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInProductMessagesCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InProductMessagesCountQuery,
    InProductMessagesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    InProductMessagesCountQuery,
    InProductMessagesCountQueryVariables
  >(InProductMessagesCountDocument, options);
}
export function useInProductMessagesCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InProductMessagesCountQuery,
    InProductMessagesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    InProductMessagesCountQuery,
    InProductMessagesCountQueryVariables
  >(InProductMessagesCountDocument, options);
}
export type InProductMessagesCountQueryHookResult = ReturnType<
  typeof useInProductMessagesCountQuery
>;
export type InProductMessagesCountLazyQueryHookResult = ReturnType<
  typeof useInProductMessagesCountLazyQuery
>;
export type InProductMessagesCountQueryResult = ApolloReactCommon.QueryResult<
  InProductMessagesCountQuery,
  InProductMessagesCountQueryVariables
>;
